var map = {
	"./pages_en": [
		6373,
		[
			373
		]
	],
	"./pages_en.js": [
		6373,
		[
			373
		]
	],
	"./pages_vi": [
		9151,
		[
			151
		]
	],
	"./pages_vi.js": [
		9151,
		[
			151
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 627;
module.exports = webpackAsyncContext;